// extracted by mini-css-extract-plugin
export var cardLayout = "_1n-1";
export var paginationContainer = "_1n-0";